/* Jason - 11112025 - Addon price - START  */
document.addEventListener('teeinblue-event-component-injected', () => {
  const PRICE_SELECTOR = "div[class*='ai-product-summary__price-'] div[class*='ai-product-summary__price-']";
  const ADDON_SELECTOR = ".tee-price-addons strong";

  const totalDiv = document.getElementById("tee-total-price");
  if(!totalDiv) return;

  // --- #formatCents ---
  function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision) {
    const roundedNumber = (moneyValue / 100).toFixed(precision);
    let [a, b] = roundedNumber.split('.');
    if (!a) a = '0';
    if (!b) b = '';

    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (d) => d + thousandsSeparator);
    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }

  // --- #formatMoney ---
  function formatMoneyTheme(moneyValue, template, currency) {
    template = template || '{{amount}}';
    currency = currency || '';

    return template.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
      if (!placeholder) return '';
      if (placeholder === 'currency') return currency;

      // default
      let thousandsSeparator = ',';
      let decimalSeparator = '.';
      let precision = 2;

      switch (placeholder) {
        case 'amount_no_decimals': precision = 0; break;
        case 'amount_with_comma_separator': thousandsSeparator = '.'; decimalSeparator = ','; break;
        case 'amount_no_decimals_with_comma_separator': thousandsSeparator = '.'; precision = 0; break;
        case 'amount_with_space_separator': thousandsSeparator = ' '; decimalSeparator = ','; break;
        case 'amount_with_period_and_space_separator': thousandsSeparator = ' '; decimalSeparator = '.'; break;
        case 'amount_with_apostrophe_separator': thousandsSeparator = "'"; decimalSeparator = '.'; break;
      }

      return formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision);
    });
  }

  // --- parse cents ---
  function parseCents(text) {
    if (!text) return 0;
    let numStr = text.replace(/[^\d.,]/g, '').trim();

    if (numStr.includes('.') && numStr.includes(',')) {
      numStr = numStr.replace(/,/g, '');
    } else if (numStr.includes(',')) {
      const parts = numStr.split(',');
      if (parts[1].length === 3) {
        numStr = parts.join('');
      } else {
        numStr = parts.join('.');
      }
    } else if (numStr.includes('.')) {
      const parts = numStr.split('.');
      if (parts[1].length === 3) {
        numStr = parts.join('');
      } 
    }

    const val = parseFloat(numStr);
    return Math.round(isNaN(val) ? 0 : val * 100);
  }

  // --- update total ---
  function updateTotal() {
    const mainEl = document.querySelector(PRICE_SELECTOR);
    const addonEl = document.querySelector(ADDON_SELECTOR);
    if (!mainEl) return;

    const mainCents = parseCents(mainEl.textContent.trim());
    const addonCents = addonEl ? parseCents(addonEl.textContent.trim()) : 0;
    const totalCents = mainCents + addonCents;

    const moneyTemplate = shopifyCurrencyFormat || '{{amount}}';
    const currency = window.shopifyCurrency || '';

    totalDiv.textContent = formatMoneyTheme(totalCents, moneyTemplate, currency);
  }
  setInterval(updateTotal, 200);
});

/* Jason - 11112025 - Addon price - END  */